import React from 'react';
import PropTypes from 'prop-types';

import styles from './SectionHeader.scss';

const SectionHeader = ({
  title,
  subtitle,
  description,
  type,
  actionButton,
  icon,
  style,
}) => (
  <header
    className={`SectionHeader ${type ? `SectionHeader--${type}` : ''}`}
    style={style}
  >
    <div className="SectionHeader__text">
      {title ? <h2 className="SectionHeader__title">{title}</h2> : null}
      {subtitle ? (
        <h2 className="SectionHeader__subtitle">{subtitle}</h2>
      ) : null}
      {description}
    </div>
    {actionButton ? (
      <div className="SectionHeader__actions">{actionButton}</div>
    ) : null}
    {icon ? icon('SectionHeader__icon') : null}
  </header>
);

SectionHeader.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  description: PropTypes.node,
  type: PropTypes.string,
  actionButton: PropTypes.node,
  // This is going to return a React node, but it’s wrapped in a
  // function that provides the className.
  icon: PropTypes.func,
  style: PropTypes.object,
};

export default SectionHeader;
